import { render, staticRenderFns } from "./FactsheetExport.vue?vue&type=template&id=5e9fef72"
import script from "./FactsheetExport.vue?vue&type=script&lang=js"
export * from "./FactsheetExport.vue?vue&type=script&lang=js"
import style0 from "./FactsheetExport.vue?vue&type=style&index=0&id=5e9fef72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports